function applyAttributes() {
  $('.cbb-also-bought-prev, .cbb-also-bought-next').attr({
    tabindex: '-1',
    'aria-hidden': 'true'
  });
}

(function ($) {

  function throttle(func, limit) {
    let inThrottle;
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments);
        inThrottle = true;
        setTimeout(() => { inThrottle = false; }, limit);
      }
    };
  }

  $(function () {

    (function () {
      var $header = $('.site-header');
      if (!$header.length) return;

      var $offsetTarget = $('main').first();
      if (!$offsetTarget.length) {
        $offsetTarget = $('body');
      }

      var isStuck = false;
      var lastScroll = window.pageYOffset || window.scrollY || 0;
      var delta = 10;

      function setOffset(enabled) {
        if (!$offsetTarget.length) return;
        if (enabled) {
          var headerHeight = $header.outerHeight() || 0;
          $offsetTarget.css('padding-top', headerHeight + 'px');
        } else {
          $offsetTarget.css('padding-top', '');
        }
      }

      $(window).on('scroll.headerSticky', throttle(function () {
        var currentScroll = window.pageYOffset || window.scrollY || $(this).scrollTop();
        var scrollDifference = Math.abs(currentScroll - lastScroll);

        if (scrollDifference < delta) return;

        if (currentScroll < 150) {
          if (isStuck) {
            $header.removeClass('header-stuck header-hidden');
            setOffset(false);
            isStuck = false;
          }
          lastScroll = currentScroll;
          return;
        }

        if (currentScroll < lastScroll) {
          if (!isStuck) {
            $header.addClass('header-stuck');
            setOffset(true);
            isStuck = true;
          }
          $header.removeClass('header-hidden');
        } else {
          if (isStuck) {
            $header.addClass('header-hidden');
          }
        }

        lastScroll = currentScroll;
      }, 50));
    })();

    (function () {
      var checkClProp = setInterval(function () {
        if ($('#CartProducts .cl-prop').length) {
          clearInterval(checkClProp);
          $('.cl-prop a').each(function () {
            var href = $(this).attr('href');
            if (href) {
              $(this).html('<img src="' + href + '" width="100" alt="Custom artwork uploaded — opens enlarge view in new tab.">');
            }
          });
        }
      }, 500);
    })();
    (function () {
      $('#mobile-hit-search').on('click', function () {
        const $search = $('.site-header__search2');

        $search.slideToggle('fast', function () {
          if ($search.is(':visible')) {
            $search.find("input[type='search'], input[type='text']").first().focus();
          }
        });

        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', String(!isExpanded));
      });
    })();

    (function () {
      $("span.meganav__link--second-level:contains('Popular')").prepend(
        '<span aria-hidden="true" class="hot_prod">🔥</span>'
      );

      // $('.pagination .page>a').each(function () {
      //   var pageLabel = $(this).text().trim();
      //   $(this).attr('aria-label', 'page ' + pageLabel);
      // });

      // $('.pagination .page.current').each(function () {
      //   var currentLabel = $(this).text().trim();
      //   $(this).html('<span class="visually-hidden">current page </span>' + currentLabel);
      // });

      // $('.pagination .next a').attr('aria-label', 'next page');
      // $('.pagination .prev a').attr('aria-label', 'previous page');

      $('.card-title-1').each(function () {
        var titleText = $(this).attr('data-collection');
        if (titleText) {
          $(this).closest('.uniq').attr('id', 'collection-list-grid-' + titleText);
        }
      });
    })();

    (function () {
      var checkCouponBox = setInterval(function () {
        if ($('.wsaio_coupon_box').length) {
          clearInterval(checkCouponBox);
          $('.wsaio_coupon_field > input').attr('aria-label', 'Discount code');
        }
      }, 1000);
    })();

    (function () {
      $('br').attr('aria-hidden', 'true');

      $('a[target="_blank"]').each(function () {
        var link = $(this);
        var href = link.attr('href') || '';
        var domainTPW = /^(https?:\/\/)?(www\.)?theparkwholesale\.com/;

        if (domainTPW.test(href) || href.startsWith('/') || href.startsWith('./') || href.startsWith('../')) {
          link.append('<span class="visually-hidden" style="color:black;background:white;">(This link opens in a new tab)</span>');
        } else {
          link.append('<span class="visually-hidden" style="color:black;background:white;">(This link opens in a new tab)</span>');
        }
      });
    })();

    (function () {
      $('.site-nav__link-toggle')
        .off('click')
        .on('click', function (event) {
          event.stopImmediatePropagation();
          $(this).toggleClass('meganav--active');
          $(this).next('.site-nav__dropdown').toggleClass('meganav--active');

          var isExpanded = $(this).attr('aria-expanded') === 'true';
          $(this).attr('aria-expanded', !isExpanded);

          $(this)
            .closest('.site-nav')
            .find('.site-nav__link-toggle')
            .not(this)
            .each(function () {
              $(this).removeClass('meganav--active');
              $(this).next('.site-nav__dropdown').removeClass('meganav--active');
              $(this).attr('aria-expanded', 'false');
            });
        });

      $(document).keydown(function (event) {
        if (event.keyCode === 27) {
          $('.site-nav__link-toggle').removeClass('meganav--active').attr('aria-expanded', 'false');
          $('.site-nav__dropdown').removeClass('meganav--active');
        }
      });

      $(document).on('click', function (event) {
        if (!$(event.target).closest('.site-nav__link-toggle, .site-nav__dropdown').length) {
          $('.site-nav__link-toggle').removeClass('meganav--active').attr('aria-expanded', 'false');
          $('.site-nav__dropdown').removeClass('meganav--active');
        }
      });
    })();

    (function () {
      var config = { childList: true, subtree: true };

      var callback = function (mutationsList, observer) {
        var prevExists = $('.cbb-also-bought-prev').length > 0;
        var nextExists = $('.cbb-also-bought-next').length > 0;

        if (prevExists || nextExists) {
          applyAttributes();
          observer.disconnect();
        }
      };

      var observer = new MutationObserver(callback);
      observer.observe(document.body, config);
    })();

    (function () {
      function addAriaAttributes() {
        $('.message.success, .message.error').attr({
          'aria-atomic': 'true',
          'aria-live': 'polite'
        });
      }

      function insertMessage() {
        const wizardHeader = document.querySelector('.action.submit');
        if (wizardHeader) {
          const messageDiv = document.createElement('div');
          messageDiv.className = 'missing_req-fields';
          messageDiv.setAttribute('aria-atomic', 'true');
          messageDiv.setAttribute('aria-live', 'polite');
          messageDiv.textContent =
            'The form has not been submitted because some required fields are missing. Please return to the top of the form and fill in each required field sequentially to submit the form.';

          wizardHeader.after(messageDiv);

          setTimeout(() => {
            messageDiv.style.display = 'none';
          }, 10000);
        }
      }

      function observeChanges() {
        const config = { attributes: true, childList: true, subtree: true };
        const observerCallback = function (mutationsList, observer) {
          mutationsList.forEach(mutation => {
            if (mutation.type === 'childList' && $('.globo-formbuilder').length) {
              addAriaAttributes();
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (target.classList.contains('panel') && target.classList.contains('errors')) {
                observer.disconnect();
                insertMessage();
              }
            }
          });
        };

        const observer = new MutationObserver(observerCallback);
        observer.observe(document.body, config);

        const submitButton = document.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener('click', () => {
            observer.observe(document.body, config);
          });
        }
      }

      observeChanges();
    })();

    (function () {
      if (window.innerWidth > 950) {
        const mobileMenu = document.querySelector('#menubtnskip');
        if (mobileMenu) {
          mobileMenu.remove();
        }
      }
    })();

    (function () {
      var originalTitle = document.title;
      var attentionTitle = '🔥 Great Prices on Top Brands';
      var titleSwitcher;

      window.addEventListener('blur', function () {
        titleSwitcher = setInterval(function () {
          document.title = (document.title === originalTitle) ? attentionTitle : originalTitle;
        }, 1000);
      });

      window.addEventListener('focus', function () {
        clearInterval(titleSwitcher);
        document.title = originalTitle;
      });
    })();

  });

})(jQuery);
document.addEventListener("DOMContentLoaded", () => {
  const freeShippingThresholdCents = 19500;
  const minimumCartValueCents = 15000;
  let lastCartTotalCents = null;

  const moneyFormat =
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    "${{amount}}";

  const moneyFormatNoDecimals = "${{amount_no_decimals}}";

  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  const formatMoneyNoDecimals = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormatNoDecimals);
    }
    return `$${Math.round(cents / 100)}`;
  };

  const getNodes = () => ({
    bar: document.getElementById("free-shipping-bar"),
    shippingMessage: document.getElementById("shipping-message"),
    progressBar: document.getElementById("progress-bar"),
    shipbarGoal: document.getElementById("shipbar-goal"),
  });

  const throttle = (fn, wait) => {
    let timeoutId = null;
    let lastCallTime = 0;
    let lastArgs, lastThis;

    return function throttled(...args) {
      const now = Date.now();
      const remaining = wait - (now - lastCallTime);

      lastArgs = args;
      lastThis = this;

      if (remaining <= 0) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = null;
        lastCallTime = now;
        fn.apply(lastThis, lastArgs);
      } else if (!timeoutId) {
        timeoutId = setTimeout(() => {
          lastCallTime = Date.now();
          timeoutId = null;
          fn.apply(lastThis, lastArgs);
        }, remaining);
      }
    };
  };

  const updateFreeShippingBar = () => {
    const { bar, shippingMessage, progressBar, shipbarGoal } = getNodes();
    if (!bar || !shippingMessage || !progressBar || !shipbarGoal) return;

    shipbarGoal.textContent = formatMoneyNoDecimals(freeShippingThresholdCents);

    fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
        return res.json();
      })
      .then((cart) => {
        const cartTotalCents = Number(cart.total_price) || 0;
        if (cartTotalCents === lastCartTotalCents) return;
        lastCartTotalCents = cartTotalCents;

        if (cartTotalCents < minimumCartValueCents) {
          bar.classList.remove("goal-complete"); // ✅ added
          bar.style.display = "none";
          bar.setAttribute("aria-hidden", "true");
          return;
        }

        const remainingCents = Math.max(
          freeShippingThresholdCents - cartTotalCents,
          0
        );
        const unlocked = remainingCents === 0;

        const progress = Math.min(
          100,
          (cartTotalCents / freeShippingThresholdCents) * 100
        );

        bar.classList.toggle("goal-complete", unlocked); // ✅ added

        shippingMessage.innerHTML = unlocked
          ? "🎉 Congrats! You Unlocked FREE SHIPPING!*"
          : `You are <strong class="shipbar-remaining">${formatMoney(
              remainingCents
            )}</strong> away from FREE SHIPPING!*`;

        progressBar.style.width = `${progress}%`;
        progressBar.setAttribute("aria-valuenow", String(Math.round(progress)));
        progressBar.classList.toggle("free-shipping-reached", unlocked);

        bar.style.display = "block";
        bar.setAttribute("aria-hidden", "false");
      })
      .catch((err) => console.error("Cart fetch error:", err));
  };

  const throttledUpdate = throttle(updateFreeShippingBar, 800);

  const isCartMutation = (url, method) => {
    const u = String(url || "");
    const m = String(method || "GET").toUpperCase();

    if (u.includes("/cart.js")) return false;
    if (m === "GET") return false;

    return /\/cart\/(add|change|update|clear)(\.js)?/.test(u);
  };

  const monitorCartChanges = () => {
    if (window.fetch) {
      const originalFetch = window.fetch;

      window.fetch = function (input, init) {
        const url =
          typeof input === "string" ? input : (input && input.url) || "";
        const method = (init && init.method) || (input && input.method) || "GET";

        return originalFetch.call(this, input, init).then((response) => {
          if (isCartMutation(url, method)) setTimeout(throttledUpdate, 0);
          return response;
        });
      };
    }

    if (window.XMLHttpRequest) {
      const open = XMLHttpRequest.prototype.open;
      const send = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__cartMethod = method;
        this.__cartUrl = url;
        return open.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        this.addEventListener("load", () => {
          if (isCartMutation(this.__cartUrl, this.__cartMethod)) {
            setTimeout(throttledUpdate, 0);
          }
        });
        return send.apply(this, arguments);
      };
    }

    document.addEventListener("cart:updated", throttledUpdate);
    document.addEventListener("ajaxCart:updated", throttledUpdate);
    document.addEventListener("cart:change", throttledUpdate);
    window.addEventListener("pageshow", throttledUpdate);
  };

  updateFreeShippingBar();
  monitorCartChanges();
});
 (() => {
  const dropdowns = [];

  function initAccessibleDropdown({
    rootSelector,
    triggerSelector,
    dropdownSelector,
    linkSelector
  }) {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const trigger = root.querySelector(triggerSelector);
    const dropdown = root.querySelector(dropdownSelector);
    const firstLink = root.querySelector(linkSelector);

    if (!trigger || !dropdown) return;

    function isOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    function openDropdown() {
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    }

    function closeDropdown({ returnFocus = false } = {}) {
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;

      if (returnFocus) {
        trigger.focus();
      }
    }

    function toggleDropdown() {
      if (isOpen()) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    trigger.addEventListener('click', toggleDropdown);

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();

        if (!isOpen()) {
          openDropdown();
        }

        firstLink?.focus();
      }

      if (event.key === 'Escape' && isOpen()) {
        event.preventDefault();
        closeDropdown({ returnFocus: true });
      }
    });

    dropdown.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDropdown({ returnFocus: true });
      }
    });

    dropdowns.push({
      root,
      close: closeDropdown
    });
  }

  initAccessibleDropdown({
    rootSelector: '.helpcenter',
    triggerSelector: '.helpcenter__trigger',
    dropdownSelector: '.helpcenter__dropdown',
    linkSelector: '.helpcenter__link'
  });

  initAccessibleDropdown({
    rootSelector: '.talktous',
    triggerSelector: '.talktous__trigger',
    dropdownSelector: '.talktous__dropdown',
    linkSelector: '.talktous__link'
  });

  document.addEventListener('click', (event) => {
    dropdowns.forEach(({ root, close }) => {
      if (!root.contains(event.target)) {
        close();
      }
    });
  });
  if (!customElements.get('header-notifications')) {
  class HeaderNotifications extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.trigger = this.querySelector('.eb-notifications__trigger');
      this.panel = this.querySelector('.eb-notifications__panel');
      this.countBadge = this.querySelector('[data-count-badge]');
      this.countText = this.querySelector('[data-count-text]');
      this.items = Array.from(this.querySelectorAll('[data-notification-key]'));

      if (!this.trigger || !this.panel) return;

      this.initialized = true;

      this.storageKey = `eb_header_notifications_read_v1_${this.dataset.shop || window.location.hostname}`;
      this.readState = this.getReadState();

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
      this.handleItemClick = this.handleItemClick.bind(this);

      this.cleanupState();
      this.render();

      this.trigger.addEventListener('click', this.handleTriggerClick);
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleDocumentKeydown);
      this.addEventListener('click', this.handleItemClick);
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.trigger.removeEventListener('click', this.handleTriggerClick);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleDocumentKeydown);
      this.removeEventListener('click', this.handleItemClick);

      this.initialized = false;
    }

    getReadState() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || {};
      } catch {
        return {};
      }
    }

    saveReadState() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.readState));
      } catch {
        // localStorage may be unavailable in private mode or restricted browsers.
      }
    }

    cleanupState() {
      const validKeys = new Set(
        this.items.map((item) => item.dataset.notificationKey).filter(Boolean)
      );

      let changed = false;

      Object.keys(this.readState).forEach((key) => {
        if (!validKeys.has(key)) {
          delete this.readState[key];
          changed = true;
        }
      });

      if (changed) {
        this.saveReadState();
      }
    }

    getUnreadCount() {
      return this.items.reduce((count, item) => {
        const key = item.dataset.notificationKey;
        return key && !this.readState[key] ? count + 1 : count;
      }, 0);
    }

    markAsRead(key) {
      if (!key || this.readState[key]) return;

      this.readState[key] = true;
      this.saveReadState();
      this.render();
    }

    render() {
      let unreadCount = 0;

      this.items.forEach((item) => {
        const key = item.dataset.notificationKey;
        const isRead = !!this.readState[key];
        const badge = item.querySelector('.eb-notifications__item-badge');
        const status = item.querySelector('[data-item-status]');
        const title = item.dataset.notificationTitle || 'Notification';

        if (!isRead) {
          unreadCount += 1;
        }

        if (badge) {
          badge.hidden = isRead;
        }

        if (status) {
          status.textContent = isRead ? '' : 'Unread notification';
        }

        item.setAttribute(
          'aria-label',
          isRead ? title : `${title}, unread notification`
        );
      });

      if (this.countBadge) {
        this.countBadge.hidden = unreadCount === 0;
        this.countBadge.textContent = unreadCount;
      }

      if (this.countText) {
        this.countText.textContent =
          unreadCount === 1
            ? '1 unread notification'
            : `${unreadCount} unread notifications`;
      }

      this.trigger.setAttribute(
        'aria-label',
        unreadCount === 0
          ? 'Notifications'
          : `Notifications, ${unreadCount} unread`
      );

      this.classList.toggle('is-has-unread', unreadCount > 0);
    }

    isOpen() {
      return !this.panel.hidden;
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');

      const firstUnread = this.items.find((item) => {
        const key = item.dataset.notificationKey;
        return key && !this.readState[key];
      });

      const firstItem = firstUnread || this.items[0];

      firstItem?.focus();
    }

    close(returnFocus = true) {
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');

      if (returnFocus) {
        this.trigger.focus();
      }
    }

    toggle() {
      this.isOpen() ? this.close() : this.open();
    }

    handleTriggerClick(event) {
      event.preventDefault();
      this.toggle();
    }

    handleDocumentClick(event) {
      if (this.isOpen() && !this.contains(event.target)) {
        this.close(false);
      }
    }

    handleDocumentKeydown(event) {
      if (event.key === 'Escape' && this.isOpen()) {
        event.preventDefault();
        this.close();
      }
    }

    handleItemClick(event) {
      const item = event.target.closest('[data-notification-key]');

      if (!item || !this.contains(item)) return;

      this.markAsRead(item.dataset.notificationKey);
    }
  }

  customElements.define('header-notifications', HeaderNotifications);
}
})();
document.addEventListener('DOMContentLoaded', function () {
  /**
   * Multi-instance Dawn-style Shopify Predictive Search
   *
   * Supports duplicated desktop/mobile search HTML.
   *
   * Required:
   * - Add data-predictive-search to each search wrapper/form
   * - Each visible search input should have a unique id
   *
   * Example:
   * <form class="site-header__search2" data-predictive-search>
   *   <input id="SiteNavSearchDesktop" type="search" name="q">
   * </form>
   *
   * <form class="site-header__search2" data-predictive-search>
   *   <input id="SiteNavSearchMobile" type="search" name="q">
   * </form>
   */

  /**
   * Destroy old single-instance version if it exists.
   */
  if (typeof window.searchAutocompleteDestroy === 'function') {
    window.searchAutocompleteDestroy();
    window.searchAutocompleteDestroy = null;
  }

  /**
   * Destroy old multi-instance version if it exists.
   */
  if (Array.isArray(window.searchAutocompleteDestroyFns)) {
    window.searchAutocompleteDestroyFns.forEach((destroyFn) => {
      if (typeof destroyFn === 'function') {
        destroyFn();
      }
    });
  }

  window.searchAutocompleteDestroyFns = [];

  const predictiveSearchContainers = document.querySelectorAll('[data-predictive-search]');

  if (!predictiveSearchContainers.length) return;

  const initializedInputs = new Set();

  predictiveSearchContainers.forEach((container, index) => {
    const form = container.matches('form')
      ? container
      : container.querySelector('form');

    if (!form) return;

    const searchInput =
      container.querySelector('input[type="search"]') ||
      container.querySelector('input[name="q"]') ||
      container.querySelector('input[id^="SiteNavSearch"]') ||
      container.querySelector('input');

    if (!searchInput || initializedInputs.has(searchInput)) return;

    initializedInputs.add(searchInput);

    initSearchAutocomplete({
      container,
      form,
      searchInput,
      index
    });
  });

  window.searchAutocompleteDestroy = function () {
    if (!Array.isArray(window.searchAutocompleteDestroyFns)) return;

    const destroyFns = [...window.searchAutocompleteDestroyFns];

    destroyFns.forEach((destroyFn) => {
      if (typeof destroyFn === 'function') {
        destroyFn();
      }
    });

    window.searchAutocompleteDestroyFns = [];
    window.searchAutocompleteDestroy = null;
  };

  function initSearchAutocomplete({ container, form, searchInput, index }) {
    const submitButton = form.querySelector('.srch-btn');

    const searchScope =
      form.closest('.site-header, .header-wrapper, header') ||
      container;

    const supportInfo =
      searchScope?.querySelector?.('.support_info') ||
      document.querySelector('.support_info');

    const MIN_QUERY_LENGTH = 2;
    const DEBOUNCE_MS = 200;
    const REQUEST_TIMEOUT_MS = 5000;
    const CACHE_MS = 15 * 60 * 1000;
    const MAX_CACHE_ITEMS = 50;
    const PRODUCT_RESULTS_LIMIT = 6;
    const OTHER_RESULTS_LIMIT = 4;

    let isDestroyed = false;
    let isInputFocused = false;
    let listboxInitialized = false;
    let listboxMouseDownAttached = false;

    let predictiveSearch = null;
    let groupsWrapper = null;
    let leftColumn = null;
    let rightColumn = null;
    let footerWrapper = null;

    if (!searchInput.id) {
      searchInput.id = `SiteNavSearch-${index + 1}-${Math.random().toString(36).slice(2)}`;
    }

    const instanceId = searchInput.id;
    const listboxId = `${instanceId}-predictive-search-results`;
    const srStatusId = `${instanceId}-search-sr-status`;

    let srStatus = document.getElementById(srStatusId);

    let debounceTimer = null;
    let announceTimer = null;
    let abortController = null;
    let requestTimeout = null;
    let latestRequestKey = '';

    let activeIndex = -1;
    let currentItems = [];
    let lastRenderedQuery = '';

    const cache = new Map();

    function getShopifyRoot() {
      return (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    }

    function buildRoute(path) {
      return `${getShopifyRoot()}${path.replace(/^\//, '')}`;
    }

    function buildSearchUrl(query, type) {
      const params = new URLSearchParams();
      params.set('q', query);

      if (type) {
        params.set('type', type);
      }

      return `${buildRoute('search')}?${params.toString()}`;
    }

    function buildSuggestUrl(query) {
      const params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'query,product,collection,page');
      params.set('resources[limit]', String(PRODUCT_RESULTS_LIMIT));
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');

      return `${buildRoute('search/suggest.json')}?${params.toString()}`;
    }

    function ensureLiveRegion() {
      if (srStatus) return srStatus;

      srStatus = document.createElement('div');
      srStatus.id = srStatusId;
      srStatus.className = 'sr-only';
      srStatus.setAttribute('data-search-sr-status', instanceId);
      srStatus.setAttribute('aria-live', 'polite');
      srStatus.setAttribute('aria-atomic', 'true');

      form.appendChild(srStatus);

      return srStatus;
    }

    function announce(message) {
      if (isDestroyed) return;

      ensureLiveRegion();

      clearTimeout(announceTimer);

      srStatus.textContent = message;

      announceTimer = setTimeout(() => {
        if (!isDestroyed && srStatus.textContent === message) {
          srStatus.textContent = '';
        }
      }, 3000);
    }

    function setupARIA() {
      searchInput.setAttribute('role', 'combobox');
      searchInput.setAttribute('aria-autocomplete', 'list');
      searchInput.setAttribute('aria-haspopup', 'listbox');
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.setAttribute('aria-controls', predictiveSearch.id);
      searchInput.setAttribute('aria-activedescendant', '');
      searchInput.setAttribute('autocomplete', 'off');
    }

    function handlePredictiveSearchMouseDown(event) {
      event.preventDefault();
    }

    function initPredictiveSearch() {
      if (predictiveSearch) return predictiveSearch;

      predictiveSearch = document.getElementById(listboxId);

      if (!predictiveSearch) {
        predictiveSearch = document.createElement('div');
        predictiveSearch.id = listboxId;
        predictiveSearch.className = 'predictive-search predictive-search--search-template search-suggestions';

        searchInput.insertAdjacentElement('afterend', predictiveSearch);
      }

      predictiveSearch.setAttribute('role', 'listbox');
      predictiveSearch.setAttribute('tabindex', '-1');

      if (!predictiveSearch.classList.contains('active')) {
        predictiveSearch.hidden = true;
      }

      groupsWrapper = predictiveSearch.querySelector('.predictive-search__results-groups-wrapper');

      if (!groupsWrapper) {
        groupsWrapper = document.createElement('div');
        groupsWrapper.id = `${instanceId}-predictive-search-results-groups-wrapper`;
        groupsWrapper.className = 'predictive-search__results-groups-wrapper';
        predictiveSearch.appendChild(groupsWrapper);
      }

      leftColumn = predictiveSearch.querySelector('.predictive-search__result-group--left');

      if (!leftColumn) {
        leftColumn = document.createElement('div');
        leftColumn.className = 'predictive-search__result-group predictive-search__result-group--left';
        groupsWrapper.appendChild(leftColumn);
      }

      rightColumn = predictiveSearch.querySelector('.predictive-search__result-group--right');

      if (!rightColumn) {
        rightColumn = document.createElement('div');
        rightColumn.className = 'predictive-search__result-group predictive-search__result-group--right';
        groupsWrapper.appendChild(rightColumn);
      }

      footerWrapper = predictiveSearch.querySelector('.predictive-search__search-for-button');

      if (!footerWrapper) {
        footerWrapper = document.createElement('div');
        footerWrapper.className = 'predictive-search__search-for-button';
        predictiveSearch.appendChild(footerWrapper);
      }

      if (!listboxMouseDownAttached) {
        predictiveSearch.addEventListener('mousedown', handlePredictiveSearchMouseDown);
        listboxMouseDownAttached = true;
      }

      return predictiveSearch;
    }

    function ensurePredictiveSearch() {
      if (listboxInitialized) return;

      initPredictiveSearch();
      setupARIA();

      listboxInitialized = true;
    }

    function setFormActiveState(active) {
      if (isDestroyed) return;

      form.classList.toggle('active', active);
      supportInfo?.classList.toggle('hidden', active);
    }

    function openSuggestions() {
      if (isDestroyed) return;

      ensurePredictiveSearch();

      if (!currentItems.length) return;

      predictiveSearch.hidden = false;
      predictiveSearch.classList.add('active', 'visible');
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function closeSuggestions() {
      if (!listboxInitialized || !predictiveSearch) return;

      predictiveSearch.classList.remove('active', 'visible');
      predictiveSearch.hidden = true;
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.setAttribute('aria-activedescendant', '');

      if (activeIndex >= 0 && currentItems[activeIndex]) {
        currentItems[activeIndex].setAttribute('aria-selected', 'false');
      }

      activeIndex = -1;
    }

    function clearAll() {
      leftColumn?.replaceChildren();
      rightColumn?.replaceChildren();
      footerWrapper?.replaceChildren();

      currentItems = [];
      activeIndex = -1;

      searchInput.setAttribute('aria-activedescendant', '');
    }

    function getOptimizedImageUrl(originalUrl, width = 150) {
      if (!originalUrl) return '';

      try {
        const url = new URL(originalUrl, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch {
        return originalUrl;
      }
    }

    function getImageData(product) {
      return (
        product?.featured_image ||
        product?.image ||
        product?.featured_media ||
        null
      );
    }

    function getImageUrl(image) {
      if (!image) return '';

      if (typeof image === 'string') {
        return image;
      }

      return image.url || image.src || '';
    }

    function getImageAlt(image) {
      if (!image || typeof image === 'string') return '';

      return image.alt || '';
    }

    function createSection({ id, heading, column }) {
      const section = document.createElement('div');

      const headingEl = document.createElement('h2');
      headingEl.id = id;
      headingEl.className = 'predictive-search__heading text-body caption-with-letter-spacing';
      headingEl.textContent = heading;

      const list = document.createElement('ul');
      list.id = `${id}-list`;
      list.className = 'predictive-search__results-list list-unstyled';
      list.setAttribute('role', 'group');
      list.setAttribute('aria-labelledby', id);

      section.appendChild(headingEl);
      section.appendChild(list);
      column.appendChild(section);

      return list;
    }

    function buildTextItem({ id, title, url, extraClass = '' }) {
      const safeTitle = title || 'Untitled';

      const li = document.createElement('li');
      li.id = id;
      li.className = `predictive-search__list-item ${extraClass}`.trim();
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');

      const a = document.createElement('a');
      a.href = url || '#';
      a.className = 'predictive-search__item link link--text';
      a.setAttribute('tabindex', '-1');

      const content = document.createElement('div');
      content.className = 'predictive-search__item-content predictive-search__item-content--centered';

      const titleEl = document.createElement('p');
      titleEl.className = 'predictive-search__item-heading h5';
      titleEl.textContent = safeTitle;

      content.appendChild(titleEl);
      a.appendChild(content);
      li.appendChild(a);

      return li;
    }

    function buildQueryItem({ id, query }) {
      const queryText = query?.text || query?.title || query?.terms || '';
      const queryUrl = query?.url || buildSearchUrl(queryText);

      return buildTextItem({
        id,
        title: queryText,
        url: queryUrl,
        extraClass: 'predictive-search__list-item--query'
      });
    }

    function buildProductItem({ id, product }) {
      const title = product?.title || 'Untitled product';
      const image = getImageData(product);
      const imageUrl = getImageUrl(image);

      const li = document.createElement('li');
      li.id = id;
      li.className = 'predictive-search__list-item predictive-search__list-item--product';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');

      const a = document.createElement('a');
      a.href = product?.url || '#';
      a.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
      a.setAttribute('tabindex', '-1');

      if (imageUrl) {
        const img = new Image();
        img.className = 'predictive-search__image';
        img.src = getOptimizedImageUrl(imageUrl, 150);
        img.alt = getImageAlt(image);
        img.width = 50;
        img.height = 50;
        img.loading = 'lazy';
        img.decoding = 'async';

        a.appendChild(img);
      }

      const content = document.createElement('div');
      content.className = 'predictive-search__item-content predictive-search__item-content--centered';

      const titleEl = document.createElement('p');
      titleEl.className = 'predictive-search__item-heading h5';
      titleEl.textContent = title;

      content.appendChild(titleEl);
      a.appendChild(content);
      li.appendChild(a);

      return li;
    }

    function addItemToList(list, item) {
      list.appendChild(item);
      currentItems.push(item);
    }

    function moveActive(newIndex) {
      if (!currentItems.length || isDestroyed) return;

      const maxIndex = currentItems.length - 1;
      const nextIndex = Math.max(0, Math.min(newIndex, maxIndex));

      if (activeIndex >= 0 && currentItems[activeIndex]) {
        currentItems[activeIndex].setAttribute('aria-selected', 'false');
      }

      activeIndex = nextIndex;

      const activeElement = currentItems[activeIndex];

      if (!activeElement) return;

      activeElement.setAttribute('aria-selected', 'true');
      searchInput.setAttribute('aria-activedescendant', activeElement.id);

      requestAnimationFrame(() => {
        if (!isDestroyed) {
          activeElement.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      });
    }

    function updateLayoutClasses({ hasLeftResults, hasProducts }) {
      if (!groupsWrapper) return;

      groupsWrapper.classList.toggle(
        'predictive-search__results-groups-wrapper--no-products',
        !hasProducts
      );

      groupsWrapper.classList.toggle(
        'predictive-search__results-groups-wrapper--no-suggestions',
        !hasLeftResults
      );
    }

    function render(data, cleanQuery) {
      if (isDestroyed) return;

      ensurePredictiveSearch();
      clearAll();

      const results = data?.resources?.results || {};

      const queries = Array.isArray(results.queries)
        ? results.queries.slice(0, OTHER_RESULTS_LIMIT)
        : [];

      const collections = Array.isArray(results.collections)
        ? results.collections.slice(0, OTHER_RESULTS_LIMIT)
        : [];

      const pages = Array.isArray(results.pages)
        ? results.pages.slice(0, OTHER_RESULTS_LIMIT)
        : [];

      const products = Array.isArray(results.products)
        ? results.products.slice(0, PRODUCT_RESULTS_LIMIT)
        : [];

      const hasQueries = queries.length > 0;
      const hasCollections = collections.length > 0;
      const hasPages = pages.length > 0;
      const hasProducts = products.length > 0;
      const hasLeftResults = hasQueries || hasCollections || hasPages;

      let suggestionCount = 0;

      updateLayoutClasses({
        hasLeftResults,
        hasProducts
      });

      /**
       * LEFT COLUMN
       * Suggestions / Collections / Pages
       */
      if (hasQueries) {
        const queryList = createSection({
          id: `${instanceId}-predictive-search-queries`,
          heading: 'Suggestions',
          column: leftColumn
        });

        queries.forEach((query, queryIndex) => {
          const queryText = query?.text || query?.title || query?.terms || '';

          if (!queryText) return;

          const item = buildQueryItem({
            id: `${instanceId}-predictive-search-option-query-${queryIndex + 1}`,
            query
          });

          addItemToList(queryList, item);
          suggestionCount++;
        });
      }

      if (hasCollections) {
        const collectionList = createSection({
          id: `${instanceId}-predictive-search-collections`,
          heading: 'Collections',
          column: leftColumn
        });

        collections.forEach((collection, collectionIndex) => {
          if (!collection?.title) return;

          const item = buildTextItem({
            id: `${instanceId}-predictive-search-option-collection-${collectionIndex + 1}`,
            title: collection.title,
            url: collection.url,
            extraClass: 'predictive-search__list-item--collection'
          });

          addItemToList(collectionList, item);
          suggestionCount++;
        });
      }

      if (hasPages) {
        const pageList = createSection({
          id: `${instanceId}-predictive-search-pages`,
          heading: 'Pages',
          column: leftColumn
        });

        pages.forEach((page, pageIndex) => {
          if (!page?.title) return;

          const item = buildTextItem({
            id: `${instanceId}-predictive-search-option-page-${pageIndex + 1}`,
            title: page.title,
            url: page.url,
            extraClass: 'predictive-search__list-item--page'
          });

          addItemToList(pageList, item);
          suggestionCount++;
        });
      }

      /**
       * RIGHT COLUMN
       * Products
       */
      if (hasProducts) {
        const productList = createSection({
          id: `${instanceId}-predictive-search-products`,
          heading: 'Products',
          column: rightColumn
        });

        products.forEach((product, productIndex) => {
          if (!product?.title) return;

          const item = buildProductItem({
            id: `${instanceId}-predictive-search-option-product-${productIndex + 1}`,
            product
          });

          addItemToList(productList, item);
          suggestionCount++;
        });
      }

      /**
       * FULL-WIDTH FOOTER BUTTON
       */
      if (cleanQuery) {
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${instanceId}-predictive-search-option-search-keywords`;
        button.className = 'predictive-search__item predictive-search__item--term link link--text h5 animate-arrow';
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', 'false');

        const buttonText = document.createElement('span');
        buttonText.textContent = `See all results for "${cleanQuery}"`;

        button.appendChild(buttonText);

        button.addEventListener('click', () => {
          if (!isDestroyed) {
            window.location.href = buildSearchUrl(cleanQuery);
          }
        });

        footerWrapper.appendChild(button);
        currentItems.push(button);
      }

      if (currentItems.length && isInputFocused) {
        openSuggestions();
      } else {
        closeSuggestions();
      }

      if (cleanQuery !== lastRenderedQuery) {
        if (suggestionCount === 0) {
          announce(`No suggestions found. See all results button available for ${cleanQuery}.`);
        } else {
          announce(
            `${suggestionCount} suggestion${suggestionCount === 1 ? '' : 's'} available. Use arrow keys to navigate and Enter to select.`
          );
        }

        lastRenderedQuery = cleanQuery;
      }
    }

    function abortCurrentRequest() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }

      if (requestTimeout) {
        clearTimeout(requestTimeout);
        requestTimeout = null;
      }

      if (predictiveSearch) {
        predictiveSearch.setAttribute('aria-busy', 'false');
      }
    }

    function fetchSuggestions(rawQuery) {
      if (isDestroyed) return;

      const cleanQuery = rawQuery.trim();

      if (!cleanQuery) {
        render({ resources: { results: {} } }, cleanQuery);
        return;
      }

      ensurePredictiveSearch();

      const cacheKey = cleanQuery.toLowerCase();
      const cached = cache.get(cacheKey);

      if (cached && Date.now() - cached.t < CACHE_MS) {
        render(cached.json, cleanQuery);
        return;
      }

      abortCurrentRequest();

      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
      }, REQUEST_TIMEOUT_MS);

      abortController = controller;
      requestTimeout = timeoutId;
      latestRequestKey = cacheKey;

      predictiveSearch.setAttribute('aria-busy', 'true');

      fetch(buildSuggestUrl(cleanQuery), {
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          return response.json();
        })
        .then((json) => {
          if (
            isDestroyed ||
            controller.signal.aborted ||
            latestRequestKey !== cacheKey
          ) {
            return;
          }

          cache.set(cacheKey, {
            json,
            t: Date.now()
          });

          if (cache.size > MAX_CACHE_ITEMS) {
            cache.delete(cache.keys().next().value);
          }

          render(json, cleanQuery);
        })
        .catch((error) => {
          if (isDestroyed || error.name === 'AbortError') return;

          announce('Failed to load search suggestions.');
        })
        .finally(() => {
          if (abortController !== controller) return;

          clearTimeout(timeoutId);

          requestTimeout = null;
          abortController = null;

          if (predictiveSearch) {
            predictiveSearch.setAttribute('aria-busy', 'false');
          }
        });
    }

    function handleInput() {
      if (isDestroyed) return;

      const rawValue = searchInput.value;
      const cleanQuery = rawValue.trim();

      clearTimeout(debounceTimer);

      if (cleanQuery.length < MIN_QUERY_LENGTH) {
        abortCurrentRequest();
        clearAll();
        closeSuggestions();
        lastRenderedQuery = '';
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchSuggestions(cleanQuery);
      }, DEBOUNCE_MS);
    }

    function handleKeyDown(event) {
      if (isDestroyed) return;

      const isOpen = listboxInitialized && predictiveSearch?.classList.contains('active');
      const hasItems = currentItems.length > 0;

      switch (event.key) {
        case 'ArrowDown':
          if (!isOpen) openSuggestions();

          if (hasItems) {
            moveActive(activeIndex < 0 ? 0 : activeIndex + 1);
            event.preventDefault();
          }

          break;

        case 'ArrowUp':
          if (!isOpen) openSuggestions();

          if (hasItems) {
            moveActive(activeIndex < 0 ? currentItems.length - 1 : activeIndex - 1);
            event.preventDefault();
          }

          break;

        case 'Home':
          if (isOpen && hasItems) {
            moveActive(0);
            event.preventDefault();
          }

          break;

        case 'End':
          if (isOpen && hasItems) {
            moveActive(currentItems.length - 1);
            event.preventDefault();
          }

          break;

        case 'Enter':
          if (isOpen && activeIndex >= 0 && currentItems[activeIndex]) {
            const activeItem = currentItems[activeIndex];

            if (activeItem.tagName === 'BUTTON') {
              event.preventDefault();
              activeItem.click();
              return;
            }

            const link = activeItem.querySelector('a[href]');

            if (link) {
              event.preventDefault();
              window.location.href = link.href;
            }
          }

          break;

        case 'Escape':
          closeSuggestions();
          announce('Suggestions closed.');
          event.preventDefault();
          break;

        default:
          break;
      }
    }

    function handleFocus() {
      if (isDestroyed) return;

      isInputFocused = true;

      ensureLiveRegion();
      ensurePredictiveSearch();
      setFormActiveState(true);

      const cleanQuery = searchInput.value.trim();

      if (cleanQuery.length >= MIN_QUERY_LENGTH) {
        if (currentItems.length) {
          openSuggestions();
        } else {
          fetchSuggestions(cleanQuery);
        }
      }
    }

    function handleBlur() {
      if (isDestroyed) return;

      setTimeout(() => {
        if (isDestroyed) return;

        const activeElement = document.activeElement;
        const insideForm = form.contains(activeElement);
        const insidePredictiveSearch = predictiveSearch?.contains(activeElement);

        if (!insideForm && !insidePredictiveSearch) {
          isInputFocused = false;
          setFormActiveState(false);
          closeSuggestions();
        }
      }, 100);
    }

    function handleOutsideClick(event) {
      if (isDestroyed) return;

      const clickedInsideForm = form.contains(event.target);
      const clickedInsidePredictiveSearch = predictiveSearch?.contains(event.target);

      if (!clickedInsideForm && !clickedInsidePredictiveSearch) {
        isInputFocused = false;
        setFormActiveState(false);
        closeSuggestions();
      }
    }

    function handleSubmitButtonMouseDown(event) {
      const isOpen = listboxInitialized && predictiveSearch?.classList.contains('active');

      if (isOpen) {
        event.preventDefault();
      }
    }

    const eventHandlers = [
      {
        element: searchInput,
        event: 'input',
        handler: handleInput
      },
      {
        element: searchInput,
        event: 'keydown',
        handler: handleKeyDown
      },
      {
        element: searchInput,
        event: 'focus',
        handler: handleFocus
      },
      {
        element: searchInput,
        event: 'blur',
        handler: handleBlur
      },
      {
        element: document,
        event: 'pointerdown',
        handler: handleOutsideClick
      }
    ];

    eventHandlers.forEach(({ element, event, handler }) => {
      element.addEventListener(event, handler);
    });

    if (submitButton) {
      submitButton.addEventListener('mousedown', handleSubmitButtonMouseDown);
    }

    function destroy() {
      if (isDestroyed) return;

      isDestroyed = true;

      clearTimeout(debounceTimer);
      clearTimeout(announceTimer);

      abortCurrentRequest();

      eventHandlers.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });

      if (submitButton) {
        submitButton.removeEventListener('mousedown', handleSubmitButtonMouseDown);
      }

      if (predictiveSearch && listboxMouseDownAttached) {
        predictiveSearch.removeEventListener('mousedown', handlePredictiveSearchMouseDown);
      }

      window.removeEventListener('pagehide', destroy);
      window.removeEventListener('beforeunload', destroy);

      currentItems = [];
      cache.clear();

      if (Array.isArray(window.searchAutocompleteDestroyFns)) {
        window.searchAutocompleteDestroyFns = window.searchAutocompleteDestroyFns.filter(
          (destroyFn) => destroyFn !== destroy
        );
      }
    }

    window.searchAutocompleteDestroyFns.push(destroy);
    window.addEventListener('pagehide', destroy);
    window.addEventListener('beforeunload', destroy);
  }
});
/* ===== mobile menu : start ===== */
(function () {
  function initMobileMenu() {
    var drawer = document.getElementById('mm-drawer');
    var overlay = document.getElementById('mm-overlay');
    if (!drawer || !overlay) return;

    var DESKTOP = '(min-width:990px)';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stack = [];
    var lastFocus = null;
    var menuBtn = null;

    function byId(id){ return document.getElementById(id); }
    function topPanel(){ return byId(stack[stack.length - 1]); }
    function allPanels(){ return drawer.querySelectorAll('.mm-panel'); }
    function syncDepth(){ drawer.classList.toggle('is-deep', stack.length > 1); }

    function setInert(el, on){
      if (!el) return;
      if (on){ el.setAttribute('inert',''); el.setAttribute('aria-hidden','true'); }
      else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
    }

    function innerOf(p){ return p.querySelector(':scope > .mm-panel__inner'); }
    function setPanelInert(p, on){ setInert(innerOf(p), on); }

    function focusables(container){
      var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
      return Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
        return el.offsetParent !== null &&
               !el.closest('[hidden]') &&
               !el.closest('[inert]') &&
               !el.closest('[aria-hidden="true"]');
      });
    }

    function afterTransition(el, cb){
      if (reduce){ cb(); return; }
      var done = false;
      function handler(e){ if (e && e.target !== el) return; if (done) return; done = true; el.removeEventListener('transitionend', handler); cb(); }
      el.addEventListener('transitionend', handler);
      setTimeout(handler, 450);
    }

    function focusPanel(panel){
      var target = panel.querySelector('[data-mm-back]') ||
                   panel.querySelector('.mm-panel__title') ||
                   focusables(panel)[0];
      if (!target) return;
      if (target.tagName !== 'BUTTON' && target.tagName !== 'A' && !target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      target.focus();
    }

    function openDrawer(){
      if (window.matchMedia(DESKTOP).matches) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      drawer.hidden = false;
      document.documentElement.classList.add('mm-lock');

      stack = ['mm-root'];
      syncDepth();
      Array.prototype.forEach.call(allPanels(), function (p) {
        var isRoot = p.id === 'mm-root';
        p.hidden = !isRoot;
        p.classList.remove('is-active', 'is-parked');
        setPanelInert(p, !isRoot);
      });
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-mm-open]'), function (b) {
        b.setAttribute('aria-expanded', 'false');
      });

      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      afterTransition(drawer, function () {
        var close = drawer.querySelector('[data-mm-close]');
        if (close) close.focus();
      });
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKey);
    }

    function closeDrawer(){
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.classList.remove('mm-lock');
      afterTransition(drawer, function () {
        drawer.hidden = true;
        overlay.hidden = true;
        Array.prototype.forEach.call(allPanels(), function (p) {
          p.classList.remove('is-active', 'is-parked');
          if (p.id !== 'mm-root') p.hidden = true;
        });
        drawer.classList.remove('is-deep');
      });
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function openPanel(id, trigger){
      var target = byId(id);
      if (!target) return;
      var current = topPanel();
      stack.push(id);
      syncDepth();
      if (trigger){ trigger.setAttribute('aria-expanded', 'true'); target._trigger = trigger; }
      target.hidden = false;
      setPanelInert(target, false);
      void target.offsetWidth;
      requestAnimationFrame(function () {
        current.classList.add('is-parked');
        setPanelInert(current, true);
        target.classList.add('is-active');
      });
      afterTransition(target, function () { focusPanel(target); });
    }

    function back(){
      if (stack.length <= 1){ closeDrawer(); return; }
      var closing = topPanel();
      stack.pop();
      syncDepth();
      var newTop = topPanel();
      closing.classList.remove('is-active');
      newTop.classList.remove('is-parked');
      setPanelInert(newTop, false);
      var trig = closing._trigger;
      if (trig) trig.setAttribute('aria-expanded', 'false');
      afterTransition(closing, function () { closing.hidden = true; setPanelInert(closing, true); });
      if (trig && trig.focus) trig.focus(); else focusPanel(newTop);
    }

    function goTo(id){
      var idx = stack.indexOf(id);
      if (idx === -1 || idx === stack.length - 1) return;
      var closing = topPanel();
      for (var i = stack.length - 1; i > idx; i--) {
        var p = byId(stack[i]);
        if (p !== closing){ p.hidden = true; setPanelInert(p, true); p.classList.remove('is-active', 'is-parked'); }
        if (p._trigger) p._trigger.setAttribute('aria-expanded', 'false');
      }
      stack = stack.slice(0, idx + 1);
      syncDepth();
      var newTop = topPanel();
      closing.classList.remove('is-active');
      newTop.classList.remove('is-parked');
      setPanelInert(newTop, false);
      afterTransition(closing, function () { closing.hidden = true; setPanelInert(closing, true); });
      focusPanel(newTop);
    }

    function onKey(e){
      if (e.key === 'Escape'){ e.preventDefault(); closeDrawer(); return; }
      if (e.key === 'Tab'){
        var f = focusables(drawer);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    }

    drawer.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-mm-open]'))){ e.preventDefault(); openPanel(t.getAttribute('data-mm-open'), t); return; }
      if (e.target.closest('[data-mm-back]')){ e.preventDefault(); back(); return; }
      if ((t = e.target.closest('[data-mm-goto]'))){ e.preventDefault(); goTo(t.getAttribute('data-mm-goto')); return; }
      if (e.target.closest('[data-mm-close]')){ e.preventDefault(); closeDrawer(); return; }
    });

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-toggle]')){ e.preventDefault(); openDrawer(); }
    });

    var existingBtn = document.getElementById('menu-btn');
    if (existingBtn) {
      menuBtn = existingBtn.cloneNode(true);
      existingBtn.parentNode.replaceChild(menuBtn, existingBtn);
      menuBtn.setAttribute('aria-expanded', 'false');
      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (drawer.hidden) openDrawer(); else closeDrawer();
      });
    }

    window.MobileMenu = { open: openDrawer, close: closeDrawer };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
})();
/* ===== mobile menu : end ===== */
